module.exports = __webpack_public_path__ + "img/backspace.4bf27b55.svg";